import { Component, OnInit, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-testimonials',
  templateUrl: './testimonials.component.html',
  styleUrls: ['./testimonials.component.scss']
})
export class TestimonialsComponent implements OnInit {

  @Input() section;
  contactNum;
  breakpoints = {
    600: {
      perView: 1.2,
      startAt: 1,
      focusAt: 'center',
      gap: 10
    },
    1200: {
      perView: 3
    }
  };
  constructor(public dialog: MatDialog) { }

  ngOnInit() {
  }

  openPopup(template, phone) {
    this.contactNum = phone;
    this.dialog.open(template, {
      maxWidth: '100vw',
      width: '478px',
      panelClass: 'testimonials-contact'
    });
  }

}
